import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconCloseBlue = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...omit(props, ["className"])}
      ref={ref}
      className="yfm-icon yfm-icon-close-blue"
    >
      <circle cx="8" cy="8" r="8" fill="#5DE5E3" />
      <path
        d="M11.6138 10.9567L5.0438 4.38608C4.86193 4.20482 4.56755 4.20482 4.3863 4.38608C4.20505 4.56733 4.20505 4.8617 4.3863 5.04357L10.9563 11.6136C11.1382 11.7948 11.4326 11.7948 11.6138 11.6136C11.7951 11.4323 11.7951 11.1379 11.6138 10.9567Z"
        fill="#17215C"
      />
      <path
        d="M11.6138 4.38608C11.4326 4.20482 11.1382 4.20482 10.9563 4.38608L4.3863 10.9567C4.20505 11.1386 4.20505 11.4323 4.3863 11.6136C4.56755 11.7948 4.86193 11.7948 5.0438 11.6136L11.6138 5.04357C11.7951 4.8617 11.7951 4.56733 11.6138 4.38608Z"
        fill="#17215C"
      />
    </svg>
  )
);

IconCloseBlue.displayName = "IconCloseBlue";

export default IconCloseBlue;
